import React, { FC } from "react";
import { Accordion, AccordionSummary, Grid, Paper } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { trafficLight } from "../../theme";




const SoKInfo: FC = () => {
    return (
        <>       
            <Grid item xs={12} sm={12} md={6} lg={12}>
                <div style={{ padding: "10px" }}>
                    <Paper variant={"outlined"} style={{ display:'flex', alignContent:'space-around'}}>
                        <Grid container spacing={1} xl={12} direction="row">
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <div style={{height: "25px", borderWidth: "1px", borderColor: "red"}}>
                                    <p style={{fontSize: "20px", position: 'relative', top: '-20px'}}>
                                        <strong>Ratings</strong></p>
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={4} md={4} lg={1}>
                                <div style={{
                                    height: '50px',
                                    backgroundColor: trafficLight.bgreen,
                                    color: trafficLight.green,
                                    borderRadius: "15px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: '12px'
                                }}><strong>Adequate</strong></div>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8} lg={3}>
                                <div style={{display: 'table', height: '50px', overflow: 'hidden'}}>
                                    <div style={{display: 'table-cell', verticalAlign: 'middle'}}>
                                        <div style={{fontSize: '12px', textAlign: 'left'}}>
                                            Adequate level of detail for <b>formal SFAIRP assessment</b>
                                        </div>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={4} md={4} lg={1}>
                                <div style={{
                                    height: '50px',
                                    backgroundColor: trafficLight.byellow,
                                    color: trafficLight.yellow,
                                    borderRadius: "15px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: '12px'
                                }}><strong>Questionable</strong></div>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8} lg={3}>
                                <div style={{display: 'table', height: '50px', overflow: 'hidden'}}>
                                    <div style={{display: 'table-cell', verticalAlign: 'middle'}}>
                                        <div style={{fontSize: '12px', textAlign: 'left'}}>
                                            <b>SFAIRP outcome is
                                                preliminary</b> unless additional investigations are carried out to
                                            address
                                            the data gaps
                                        </div>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={4} md={4} lg={1}>
                                <div style={{
                                    height: '50px',
                                    backgroundColor: trafficLight.bred,
                                    color: trafficLight.red,
                                    borderRadius: "15px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: '12px'
                                }}><strong>Inadequate</strong></div>
                                <div><br/></div>
                            </Grid>
                            <Grid item xs={12} sm={8} md={4} lg={3}>
                                <div style={{display: 'table', height: '50px', overflow: 'hidden'}}>
                                    <div style={{display: 'table-cell', verticalAlign: 'middle'}}>
                                        <div style={{fontSize: '12px', textAlign: 'left'}}>
                                            Inadequate for SFAIRP assessment <b>SFAIRP outcome is preliminary or
                                            indeterminate</b>
                                        </div>
                                    </div>
                                </div>
                            </Grid>

                        </Grid>

                    </Paper>

                </div>
            </Grid>
        
        
        </>)
}


export default SoKInfo;
